import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'reactstrap';
import PhoneListingsTile from './PhoneListingTile';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";



function EirPhoneListings(props) {


    const renderContent = (content) => {
        return { __html: content };
    }
    useEffect(() => {
    })


    return (
        <div id={"phone-listings-ctr-" + props.occurence} class="phone-listings-main pt-4 pb-5">
            {(!isMobileOnly) && (props.HideComponent !== "Desktop") && (props.HideComponent !== "Both") &&
                <div>
                    <div className="homepage-modules-title" dangerouslySetInnerHTML={renderContent(props.moduleDesktopTitle)}></div>
                    <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
                        <Row >
                            {props.desktoptiles.map((tile, i) => {
                                return (
                                    <Col className={'phone-listing-desktop mt-mb-30 col-3'} >
                                        <PhoneListingsTile tile={tile} ctaImage={props.CTAIcon} ctaHoverImage={props.CTAHoverIcon} id={'pl-tile' + (i + 1)}>
                                        </PhoneListingsTile>
                                    </Col>
                                );
                            })
                            }
                        </Row>
                    </Container>
                </div>
            }
             {(isMobileOnly) && (props.HideComponent !== "Mobile") && (props.HideComponent !== "Both") &&
                <div>
                    <div className="homepage-modules-title" dangerouslySetInnerHTML={renderContent(props.moduleDesktopTitle)}></div>
                    <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
                        <Row >
                            {props.desktoptiles.map((tile, i) => {
                                return (
                                    <Col className={'phone-listing-desktop mt-mb-30 col-6'} >
                                        <PhoneListingsTile tile={tile} ctaImage={props.CTAIcon} ctaHoverImage={props.CTAHoverIcon} id={'pl-tile' + (i + 1)}>
                                        </PhoneListingsTile>
                                    </Col>
                                );
                            })
                            }
                        </Row>
                    </Container>
                </div>
            }
        </div>
    );
}
export default EirPhoneListings;

